var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 67,
    viewBox: "0 0 76 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2302 35.3733C39.4455 27.0305 47.9169 22.0723 56.1517 24.2989C60.1062 25.3681 63.4761 27.9851 65.5201 31.5741C67.5641 35.1631 68.1148 39.4302 67.0509 43.4366C64.8357 51.7794 56.3642 56.7376 48.1295 54.511C39.8947 52.2844 35.0149 43.7162 37.2302 35.3733ZM63.5285 55.5382L67.0151 60.3317L67.0922 60.3526C67.7489 61.5057 67.3571 62.9814 66.217 63.6487C65.0769 64.3159 63.6203 63.9221 62.9636 62.769L60.4026 57.5392C60.1476 57.0933 60.0787 56.5626 60.211 56.0643C60.3433 55.566 60.666 55.1412 61.1077 54.8836C61.9572 54.3964 63.0342 54.6876 63.5285 55.5382Z",
    fill: "url(#paint0_linear_21_27)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_21_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3302 31.1712C49.8456 29.9602 45.23 32.6651 44.0209 37.2128C42.8118 41.7605 45.467 46.4289 49.9516 47.6399C54.4361 48.8509 59.0517 46.146 60.2608 41.5983C60.8414 39.4144 60.5428 37.0889 59.4306 35.1335C58.3184 33.178 56.4837 31.7528 54.3302 31.1712Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_21_27)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_21_27)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_21_27",
    maskUnits: "userSpaceOnUse",
    x: -1.51403,
    y: -1.21785,
    width: 68.4527,
    height: 68.7193,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -1.51403,
    y: -1.21785,
    width: 68.4527,
    height: 68.7193
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8294 22.5326C54.5251 10.0882 41.8889 2.69247 29.6057 6.01372C23.7071 7.60865 18.6805 11.5122 15.6316 16.8657C12.5827 22.2191 11.7613 28.5839 13.3481 34.5599C16.6525 47.0043 29.2887 54.4 41.5719 51.0788C53.855 47.7575 61.1338 34.977 57.8294 22.5326ZM18.6033 52.6123L13.4026 59.7625L13.2876 59.7936C12.308 61.5136 12.8925 63.7148 14.5931 64.7101C16.2936 65.7054 18.4663 65.1179 19.4459 63.3979L23.2659 55.5971C23.6463 54.9319 23.7491 54.1403 23.5518 53.397C23.3544 52.6538 22.8731 52.0201 22.2141 51.636C20.947 50.9092 19.3406 51.3436 18.6033 52.6123Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8294 22.5326C54.5251 10.0882 41.8889 2.69247 29.6057 6.01372C23.7071 7.60865 18.6805 11.5122 15.6316 16.8657C12.5827 22.2191 11.7613 28.5839 13.3481 34.5599C16.6525 47.0043 29.2887 54.4 41.5719 51.0788C53.855 47.7575 61.1338 34.977 57.8294 22.5326ZM18.6033 52.6123L13.4026 59.7625L13.2876 59.7936C12.308 61.5136 12.8925 63.7148 14.5931 64.7101C16.2936 65.7054 18.4663 65.1179 19.4459 63.3979L23.2659 55.5971C23.6463 54.9319 23.7491 54.1403 23.5518 53.397C23.3544 52.6538 22.8731 52.0201 22.2141 51.636C20.947 50.9092 19.3406 51.3436 18.6033 52.6123Z",
    fill: "white",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6057 6.01372L29.863 6.98006L29.6057 6.01372ZM57.8294 22.5326L58.7949 22.2722L57.8294 22.5326ZM15.6316 16.8657L14.7643 16.3718L14.7643 16.3718L15.6316 16.8657ZM13.3481 34.5599L14.3136 34.2995L14.3136 34.2995L13.3481 34.5599ZM41.5719 51.0788L41.8291 52.0451L41.8291 52.0451L41.5719 51.0788ZM13.4026 59.7625L14.2093 60.3502C14.0745 60.5355 13.8806 60.6691 13.6599 60.7288L13.4026 59.7625ZM18.6033 52.6123L19.4662 53.1138C19.449 53.1435 19.4302 53.1723 19.41 53.2L18.6033 52.6123ZM13.2876 59.7936L12.4203 59.2997C12.5528 59.0671 12.7725 58.897 13.0304 58.8272L13.2876 59.7936ZM19.4459 63.3979L20.3425 63.8364C20.3333 63.8552 20.3235 63.8736 20.3132 63.8918L19.4459 63.3979ZM23.2659 55.5971L22.3694 55.1586C22.3788 55.1393 22.3889 55.1204 22.3995 55.1017L23.2659 55.5971ZM23.5518 53.397L24.5173 53.1367L23.5518 53.397ZM22.2141 51.636L22.7127 50.7668L22.7187 50.7703L22.2141 51.636ZM29.3485 5.04738C42.1758 1.579 55.3517 9.30461 58.7949 22.2722L56.8639 22.793C53.6985 10.8718 41.602 3.80594 29.863 6.98006L29.3485 5.04738ZM14.7643 16.3718C17.9447 10.7874 23.1902 6.71253 29.3485 5.04738L29.863 6.98006C24.2241 8.50476 19.4163 12.237 16.4989 17.3595L14.7643 16.3718ZM12.3826 34.8203C10.7287 28.5917 11.5842 21.9557 14.7643 16.3718L16.4989 17.3595C13.5813 22.4825 12.7939 28.5762 14.3136 34.2995L12.3826 34.8203ZM41.8291 52.0451C29.0018 55.5135 15.8259 47.7879 12.3826 34.8203L14.3136 34.2995C17.4791 46.2207 29.5755 53.2866 41.3146 50.1124L41.8291 52.0451ZM58.7949 22.2722C62.2381 35.2393 54.6559 48.5769 41.8291 52.0451L41.3146 50.1124C53.0541 46.9382 60.0295 34.7146 56.8639 22.793L58.7949 22.2722ZM12.5959 59.1747L17.7966 52.0245L19.41 53.2L14.2093 60.3502L12.5959 59.1747ZM13.0304 58.8272L13.1453 58.7961L13.6599 60.7288L13.5449 60.7599L13.0304 58.8272ZM14.087 65.5748C11.9142 64.3031 11.1695 61.496 12.4203 59.2997L14.1549 60.2875C13.4466 61.5312 13.8709 63.1264 15.0992 63.8453L14.087 65.5748ZM20.3132 63.8918C19.0578 66.0961 16.2678 66.8512 14.087 65.5748L15.0992 63.8453C16.3195 64.5596 17.8749 64.1397 18.5786 62.904L20.3132 63.8918ZM24.1625 56.0356L20.3425 63.8364L18.5493 62.9594L22.3694 55.1586L24.1625 56.0356ZM24.5173 53.1367C24.7819 54.1331 24.6447 55.1966 24.1324 56.0925L22.3995 55.1017C22.6479 54.6673 22.7164 54.1475 22.5863 53.6574L24.5173 53.1367ZM22.7187 50.7703C23.6068 51.288 24.2527 52.1401 24.5173 53.1367L22.5863 53.6574C22.4562 53.1674 22.1394 52.7522 21.7096 52.5016L22.7187 50.7703ZM17.7404 52.1108C18.7542 50.3661 20.9688 49.7667 22.7127 50.7668L21.7156 52.5051C20.9253 52.0518 19.9269 52.3211 19.4662 53.1138L17.7404 52.1108Z",
    fill: "url(#paint1_linear_21_27)",
    mask: "url(#path-3-outside-1_21_27)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_21_27",
    x: 28.7288,
    y: 15.8823,
    width: 46.822,
    height: 47.0464,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_21_27"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_21_27",
    x: -12.4417,
    y: -19.7822,
    width: 96.0664,
    height: 109.978,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_21_27",
    x: -12.4417,
    y: -19.7822,
    width: 96.0664,
    height: 109.978,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_27",
    x1: 76.1191,
    y1: 29.6909,
    x2: 29.6937,
    y2: 50.3924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_27",
    x1: 45.2049,
    y1: 8.29425,
    x2: 12.8736,
    y2: 62.5946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.24cf87de228205e5c6f7ea9fdfed3066.svg";
export { ForwardRef as ReactComponent };